export const NEW_STACK_NAME = "DoitCmpNewRole";
export const UPDATE_STACK_NAME = "DoitCmpExistingRole";
export const DEFAULT_ROLE_NAME = "doitintl-cmp";
export const SNS_ARN = "arn:aws:sns:us-east-1:068664126052:doitintl-aws-connect";
export const REAL_TIME_DATA_SNS_PROD_ACCOUNT_ID = "676206900418";
export const REAL_TIME_DATA_SNS_DEV_ACCOUNT_ID = "913524940965";
